<template>
  <UiBox class="ui-box-apply" bgType="light" layout="single">
    <template v-slot:nav-left>
      <UiTab class="title">
        <i></i>
        <div class="label-box">
          <span class="label-shadow">报名成功</span>
          <span class="label-text">报名成功</span>
        </div>
      </UiTab>
    </template>
    <template v-slot:container>
      <div class="inner-container">
        <div class="scroll-box">
          <div class="info-box">
            <div class="tip">
              <div
                class="icon"
                :class="{
                  pass: lg(Info, 'approval_status', 0) === 0 || lg(Info, 'approval_status', 0) === 1,
                  unpass: lg(Info, 'approval_status', 0) === 2
                }"
              ></div>
              <div class="desc">{{ sub_tip }}</div>
            </div>
            <div class="progress-box">
              <div class="bg" :class="status"></div>
              <div class="filter" :class="{ active: lg(Info, 'team_status', 0) >= 0 }">
                <div class="label-box">
                  <span class="label-shadow">初筛</span>
                  <span class="label-text">初筛</span>
                </div>
                <div class="icon"></div>
              </div>
              <div class="filter" :class="{ active: lg(Info, 'team_status', 0) >= 2 }">
                <div class="label-box">
                  <span class="label-shadow">复筛</span>
                  <span class="label-text">复筛</span>
                </div>
                <div class="icon"></div>
              </div>
              <div class="filter" :class="{ active: lg(Info, 'team_status', 0) >= 3 }">
                <div class="label-box">
                  <span class="label-shadow">终筛</span>
                  <span class="label-text">终筛</span>
                </div>
              </div>
            </div>
            <div class="players">
              <li v-for="(item, i) in player" :key="i">
                <span><i>{{ item.label }}: </i>{{ item.nick || '-' }}</span>
                <span><i>UID: </i>{{ item.uid || '-' }}</span>
              </li>
            </div>
          </div>
        </div>
        <div class="bottom-box">
          <UiButton class="btn prev" colorType="gold" @click="handleExit">
            <div class="label-box">
              <span class="label-shadow">完成</span>
              <span class="label-text">完成</span>
            </div>
          </UiButton>
        </div>
      </div>
    </template>
  </UiBox>
</template>

<script setup>
import { ref, computed, watch, inject } from 'vue'
import lg from '@/utils/lg'
import { useConfig } from '@/composables/useConfig'
import UiBox from '@/components/ui-box';
import UiTab from '@/components/ui-tab';
import UiButton from '@/components/ui-button';

const info_player = inject('info_player')
const apply_info = inject('apply_info')
const handleStep = inject('handleStep')

const config = useConfig()

const sub_tip = ref('')
const status = ref('stage-1')

const player = computed(() => {
  return info_player() || [];
})
const tips = computed(() => lg(config.value, 'tips', {}))
const Info = computed(() => {
  return apply_info()
})

// (team_status, approval_status) → tips key — 必须在使用它的 watch 之前定义
const TIP_MAP = {
  0: { 0: 'filter_early_default', 1: 'filter_early_pass', 2: 'filter_early_unpass' },
  1: { 0: 'filter_early_default', 1: 'filter_early_pass', 2: 'filter_early_unpass' },
  2: { 0: 'filter_early_pass',    1: 'filter_again_pass', 2: 'filter_again_unpass' },
  3: { 0: 'filter_again_pass',    1: 'filter_final_pass', 2: 'filter_final_unpass' }
}
function getTip(filter, pass) {
  const row = TIP_MAP[filter || 0]
  const key = row && row[pass || 0]
  sub_tip.value = key ? (tips.value[key] || '') : ''
}

watch(
  Info,
  (val, oldVal) => {
    if(val !== oldVal) {
      let team_status = val.team_status;
      let approval_status = val.approval_status;
      getTip(team_status, approval_status)
      // 判断阶段
      if(team_status >= 3) {
        status.value = 'stage-3'
      }else if(team_status >= 2) {
        status.value = 'stage-2'
      }else if(team_status >= 0) {
        status.value = 'stage-1'
      }
    }
  },
  { immediate: true, deep: true }
)

watch(
  tips,
  (val, oldVal) => {
    if(val !== oldVal) {
      let team_status = lg(Info.value, 'team_status', 0);
      let approval_status = lg(Info.value, 'approval_status', 0);
      getTip(team_status, approval_status)
    }
  },
  { immediate: true }
)

function handleExit() {
  handleStep(1)
}
</script>

<style lang="scss" scoped>
.title {
  font-weight: 500;
  i {
    position: relative;
    @include r(width, 36);
    @include r(height, 36);
    @include icon_status('apply_success_2');
    margin-right: get_vh(8);
  }
  .label-box {
    .label-shadow {
      color: #FFFFFF;
    }
    .label-text {
      color: #890002;
    }
  }
}


.inner-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .scroll-box {
    flex: 1;
    width: 98.5%;
    margin: get_vh(66) auto 0;
    overflow-y: scroll;
    overflow-x: hidden;
    .info-box {
      width: get_vw(822);
      margin: 0 auto;
      text-align: center;
      .tip {
        min-height: get_vh(68);
        max-width: get_vw(768);
        margin: 0 auto get_vh(18);
        display: flex;
        flex-direction: column;
        align-items: center;
        .icon {
          width: get_vh(126);
          height: get_vh(126);
          margin-bottom: get_vh(16);
          flex-shrink: 0;
          background: url(https://website.xdcdn.net/poster/58881/26match/icon/P9kaqtin.png) center/contain no-repeat;
          &.unpass { background-image: url(https://website.xdcdn.net/poster/58881/26match/icon/P9kaqvq8.png); }
        }
        .desc {
          flex: 1;
          @include r(font-size, 24);
          color: #000;
        }
      }
      .progress-box {
        position: relative;
        height: get_vw(45);
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: #DEDEDE;
        border: get_vh(2) solid #CCCCCC;
        margin-bottom: get_vh(18);
        .bg {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, #F61A24 0%, #900F15 100%);
          &.stage-1 {
            width: 33.3333%;
          }
          &.stage-2 {
            width: 66.6666%;
          }
          &.stage-3 {
            width: 100%;
          }
        }
        .filter {
          position: relative;
          width: get_vw(274);
          height: 100%;
          border-radius: get_vh(10);
          display: flex;
          align-items: center;
          justify-content: center;
          @include r(font-size, 24);
          // font-size: get_vh(24);
          .icon {
            position: absolute;
            top: 50%;
            right: get_vh(22);
            transform: translate3d(0, -50%, 0);
            width: get_vh(37);
            height: get_vh(19);
            background: url(https://website.xdcdn.net/poster/58881/26match/icon/P9lRPpsl.png) center/contain no-repeat;
          }
          .label-box {
            .label-shadow {
              color: transparent;
            }
            .label-text {
              color: #999;
            }
          }
          &.active {
            .icon {
              background-image: url(https://website.xdcdn.net/poster/58881/26match/icon/P9lPZuv9.png);
            }
            .label-box {
              .label-shadow {
                color: #890002;
              }
              .label-text {
                color: #FFFFFF;
              }
            }
          }
        }
      }
      .players {
        padding: get_vh(26) 0;
        background-color: #FFFFFF;
        border: get_vh(2) solid #CCCCCC;
        li {
          width: get_vw(746);
          height: get_vh(40);
          margin: 0 auto;
          color: #333;
          @include r(font-size, 20);
          display: flex;
          justify-content: space-between;
          align-items: center;
          i {
            color: #cccccc;
            font-style: normal;
          }
        }
      }
    }
  }
  .bottom-box {
    height: get_vh(128);
    display: flex;
    justify-content: center;
    .btn {
      position: relative;
      width: get_vh(266);
      height: get_vh(71);
      font-size: get_vh(30);
      font-weight: bold;
      cursor: pointer;
      -webkit-tap-highlight-color: transparent;
      margin-top: get_vh(20);
      &:active {
        opacity: 0.9;
      }
    }
  }
}
</style>